import { Component, Input, OnInit } from "@angular/core";
import {
  LayoutViewModel,
  LayoutZoneViewModel,
} from "../view-models/layout.view-model";
import { Router } from "@angular/router";
import { ELayoutZoneType } from "../../../domain/layouts/layoutZone";

@Component({
  selector: "evrideo-zone-editor",
  templateUrl: "./zone-editor.component.html",
  styleUrls: ["./zone-editor.component.scss"],
})
export class ZoneEditorComponent implements OnInit {
  readonly ELayoutZoneType = ELayoutZoneType;

  @Input()
  layoutViewModel: LayoutViewModel;
  @Input()
  vm: LayoutZoneViewModel;
  constructor(public router: Router) {}

  ngOnInit(): void {}
}
